import { memo, useState } from "react";

import { Handle } from "reactflow";

import style from "@styles/pages/flow/boxes/Box.module.scss";

import { BoxTitles } from "@boxes/BoxTitles";
import { BoxTypes } from "@boxes/BoxTypes";
import { BoxValidations } from "@boxes/BoxValidations";
import { ForEach, If } from "@components/control-statements";

import classnames from "classnames/bind";
const css = classnames.bind(style);

export default memo(({ data, selected, isConnectable }) => {
  const [collapse, setCollapse] = useState(false);

  return (
    <div className={css({ selected: selected })}>
      <div
        className={css({
          inner: true,
          group: true,
          needsSetup: !BoxValidations.validate(BoxTypes.AudienceGroup, data),
        })}
      >
        <div className={style.header} onClick={() => setCollapse(!collapse)}>
          <div className={style.icon}>
            <i className="far fa-layer-group" />
          </div>
          <div className="d-flex align-center justify-between flex-1">
            <div className="d-flex flex-column">
              <p className={style.title}>{BoxTitles.AudienceGroup}</p>
              <span className={style.subtitle}>
                {data.audiences?.length || 0} públicos aplicados
              </span>
            </div>
            <If cond={data.audiences?.length}>
              <div className={css({ chevron: true, rotate: collapse })}>
                <i className="fas fa-chevron-down" />
              </div>
            </If>
          </div>
        </div>

        {collapse && (
          <div className={style.collapse}>
            <ul>
              <ForEach
                items={data.audiences || []}
                render={(audience, aIdx) => (
                  <li>
                    <p>{audience?.data?.name}</p>
                    <div
                      key={`a_${new Date().getTime()}_${aIdx}`}
                      className={style.setup}
                      onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        e.target.parentNode.dispatchEvent(
                          new CustomEvent("click", {
                            bubbles: true,
                            detail: { setup: true, audienceId: audience.id },
                          })
                        );
                      }}
                    >
                      <i className="far fa-gear" />
                    </div>
                  </li>
                )}
              />
            </ul>
          </div>
        )}
      </div>

      <Handle
        type="target"
        position="left"
        className={style.handleTarget}
        isConnectable={isConnectable}
      />
      <Handle
        type="source"
        position="right"
        className={style.handleSource}
        isConnectable={isConnectable}
      />
    </div>
  );
});
